import { twMerge } from "tailwind-merge";

type ProgressBarProps = {
  color?: string;
  value: number | undefined;
};

export function ProgressBarView({ color, value }: ProgressBarProps) {
  return (
    <div className="w-full flex items-center gap-1 my-2">
      <div className="h-2 w-full rounded-md bg-gray-200 overflow-hidden relative">
        <div
          className={twMerge("h-2 w-full rounded-md", color)}
          style={{
            width: `${value}%`,
          }}
        ></div>
      </div>
    </div>
  );
}
